"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingChangeDTO = exports.ObjectRemoveDTO = exports.ObjectPlaceDTO = exports.ObjectMoveDTO = exports.MilestoneDTO = exports.ChallengeMilestoneDTO = exports.ChallengeCompleteDTO = exports.ChallengeBeginDTO = exports.BoardEnterDTO = exports.BoardDestroyDTO = exports.BoardCreateDTO = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
const utility_1 = require("../decorators/utility");
const game_related_1 = require("../types/game-related");
let BoardCreateDTO = class BoardCreateDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.BoardCreateDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Board ID'),
    __metadata("design:type", String)
], BoardCreateDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of board'),
    __metadata("design:type", String)
], BoardCreateDTO.prototype, "boardName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Type of board'),
    __metadata("design:type", String)
], BoardCreateDTO.prototype, "boardType", void 0);
BoardCreateDTO = __decorate([
    (0, decorators_1.Describe)('Board Create event')
], BoardCreateDTO);
exports.BoardCreateDTO = BoardCreateDTO;
let BoardDestroyDTO = class BoardDestroyDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.BoardDestroyDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meta", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Board ID'),
    __metadata("design:type", String)
], BoardDestroyDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of board'),
    __metadata("design:type", String)
], BoardDestroyDTO.prototype, "boardName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Type of board'),
    __metadata("design:type", String)
], BoardDestroyDTO.prototype, "boardType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional information on board status on destroy'),
    __metadata("design:type", String)
], BoardDestroyDTO.prototype, "meta", void 0);
BoardDestroyDTO = __decorate([
    (0, decorators_1.Describe)('Board Destroy event')
], BoardDestroyDTO);
exports.BoardDestroyDTO = BoardDestroyDTO;
let BoardEnterDTO = class BoardEnterDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.BoardEnterDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Board ID'),
    __metadata("design:type", String)
], BoardEnterDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of board'),
    __metadata("design:type", String)
], BoardEnterDTO.prototype, "boardName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Type of board'),
    __metadata("design:type", String)
], BoardEnterDTO.prototype, "boardType", void 0);
BoardEnterDTO = __decorate([
    (0, decorators_1.Describe)('Board Enter event')
], BoardEnterDTO);
exports.BoardEnterDTO = BoardEnterDTO;
let ChallengeBeginDTO = class ChallengeBeginDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ChallengeBeginDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "challengeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requirements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rewards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "endDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meta", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Challenge type'),
    __metadata("design:type", String)
], ChallengeBeginDTO.prototype, "challengeType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique name or ID of challenge'),
    __metadata("design:type", String)
], ChallengeBeginDTO.prototype, "name", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Requirement, minSize: 1 }),
    (0, decorators_1.Describe)('Array of challenge requirements'),
    __metadata("design:type", Array)
], ChallengeBeginDTO.prototype, "requirements", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Item, minSize: 1 }),
    (0, decorators_1.Describe)('Array of challenge rewards'),
    __metadata("design:type", Array)
], ChallengeBeginDTO.prototype, "rewards", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Challenge start date, if timed'),
    __metadata("design:type", String)
], ChallengeBeginDTO.prototype, "startDate", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Challenge end date, if timed'),
    __metadata("design:type", String)
], ChallengeBeginDTO.prototype, "endDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional information pertaining to start of challenge'),
    __metadata("design:type", String)
], ChallengeBeginDTO.prototype, "meta", void 0);
ChallengeBeginDTO = __decorate([
    (0, decorators_1.Describe)('Challenge Begin event')
], ChallengeBeginDTO);
exports.ChallengeBeginDTO = ChallengeBeginDTO;
let ChallengeCompleteDTO = class ChallengeCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ChallengeCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "challengeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requirements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rewards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "endDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meta", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Challenge type'),
    __metadata("design:type", String)
], ChallengeCompleteDTO.prototype, "challengeType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique name or ID of challenge'),
    __metadata("design:type", String)
], ChallengeCompleteDTO.prototype, "name", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Requirement, minSize: 1 }),
    (0, decorators_1.Describe)('Array of challenge requirements'),
    __metadata("design:type", Array)
], ChallengeCompleteDTO.prototype, "requirements", void 0);
__decorate([
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Item, minSize: 1 }),
    (0, decorators_1.Describe)('Array of challenge rewards'),
    __metadata("design:type", Array)
], ChallengeCompleteDTO.prototype, "rewards", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Challenge start date, if timed'),
    __metadata("design:type", String)
], ChallengeCompleteDTO.prototype, "startDate", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Challenge end date, if timed'),
    __metadata("design:type", String)
], ChallengeCompleteDTO.prototype, "endDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional information pertaining to completion of challenge'),
    __metadata("design:type", String)
], ChallengeCompleteDTO.prototype, "meta", void 0);
ChallengeCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Challenge Complete event')
], ChallengeCompleteDTO);
exports.ChallengeCompleteDTO = ChallengeCompleteDTO;
let ChallengeMilestoneDTO = class ChallengeMilestoneDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ChallengeMilestoneDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "challengeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "milestoneType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rewards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "endDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meta", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Challenge type'),
    __metadata("design:type", String)
], ChallengeMilestoneDTO.prototype, "challengeType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique name or ID of challenge'),
    __metadata("design:type", String)
], ChallengeMilestoneDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Milestone type'),
    __metadata("design:type", String)
], ChallengeMilestoneDTO.prototype, "milestoneType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, utility_1.ArrayOfType)({ type: () => game_related_1.Item, minSize: 1 }),
    (0, decorators_1.Describe)('Array of challenge rewards'),
    __metadata("design:type", Array)
], ChallengeMilestoneDTO.prototype, "rewards", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Challenge start date, if timed'),
    __metadata("design:type", String)
], ChallengeMilestoneDTO.prototype, "startDate", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Challenge end date, if timed'),
    __metadata("design:type", String)
], ChallengeMilestoneDTO.prototype, "endDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Additional information pertaining to completion of challenge'),
    __metadata("design:type", String)
], ChallengeMilestoneDTO.prototype, "meta", void 0);
ChallengeMilestoneDTO = __decorate([
    (0, decorators_1.Describe)('Challenge Milestone event')
], ChallengeMilestoneDTO);
exports.ChallengeMilestoneDTO = ChallengeMilestoneDTO;
let MilestoneDTO = class MilestoneDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.MilestoneDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stepNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timeTaken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Milestone name'),
    __metadata("design:type", String)
], MilestoneDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Step number'),
    __metadata("design:type", Number)
], MilestoneDTO.prototype, "stepNumber", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Time taken to achieve'),
    __metadata("design:type", Number)
], MilestoneDTO.prototype, "timeTaken", void 0);
MilestoneDTO = __decorate([
    (0, decorators_1.Describe)('Milestone event')
], MilestoneDTO);
exports.MilestoneDTO = MilestoneDTO;
let ObjectMoveDTO = class ObjectMoveDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ObjectMoveDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "objectId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "objectName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "objectType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNFT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "costCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "earnCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "earnAmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "earnInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coordinates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "proximityEffects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Object ID'),
    __metadata("design:type", String)
], ObjectMoveDTO.prototype, "objectId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Object Name'),
    __metadata("design:type", String)
], ObjectMoveDTO.prototype, "objectName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Object type'),
    __metadata("design:type", String)
], ObjectMoveDTO.prototype, "objectType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Board ID'),
    __metadata("design:type", String)
], ObjectMoveDTO.prototype, "boardId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Is object an NFT?'),
    __metadata("design:type", Boolean)
], ObjectMoveDTO.prototype, "isNFT", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Cost of moving object'),
    __metadata("design:type", Number)
], ObjectMoveDTO.prototype, "cost", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency of cost'),
    __metadata("design:type", String)
], ObjectMoveDTO.prototype, "costCurrency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Earnings currency'),
    __metadata("design:type", String)
], ObjectMoveDTO.prototype, "earnCurrency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Amount of earnings per interval'),
    __metadata("design:type", Number)
], ObjectMoveDTO.prototype, "earnAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Earning interval in seconds'),
    __metadata("design:type", Number)
], ObjectMoveDTO.prototype, "earnInterval", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => game_related_1.Coordinates),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, decorators_1.Describe)('Coordinates where object placed'),
    __metadata("design:type", game_related_1.Coordinates)
], ObjectMoveDTO.prototype, "coordinates", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => game_related_1.ProximityEffectOptional),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, decorators_1.Describe)('Array of proximity effects'),
    __metadata("design:type", Array)
], ObjectMoveDTO.prototype, "proximityEffects", void 0);
ObjectMoveDTO = __decorate([
    (0, decorators_1.Describe)('Object moved event')
], ObjectMoveDTO);
exports.ObjectMoveDTO = ObjectMoveDTO;
let ObjectPlaceDTO = class ObjectPlaceDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ObjectPlaceDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "objectId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "objectName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "objectType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNFT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "costCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "earnCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "earnAmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "earnInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coordinates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "proximityEffects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Object ID'),
    __metadata("design:type", String)
], ObjectPlaceDTO.prototype, "objectId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Object Name'),
    __metadata("design:type", String)
], ObjectPlaceDTO.prototype, "objectName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Object type'),
    __metadata("design:type", String)
], ObjectPlaceDTO.prototype, "objectType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Board ID'),
    __metadata("design:type", String)
], ObjectPlaceDTO.prototype, "boardId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Is object an NFT?'),
    __metadata("design:type", Boolean)
], ObjectPlaceDTO.prototype, "isNFT", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Cost of placing object'),
    __metadata("design:type", Number)
], ObjectPlaceDTO.prototype, "cost", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency of cost'),
    __metadata("design:type", String)
], ObjectPlaceDTO.prototype, "costCurrency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Earnings currency'),
    __metadata("design:type", String)
], ObjectPlaceDTO.prototype, "earnCurrency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Amount of earnings per interval'),
    __metadata("design:type", Number)
], ObjectPlaceDTO.prototype, "earnAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Earning interval in seconds'),
    __metadata("design:type", Number)
], ObjectPlaceDTO.prototype, "earnInterval", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => game_related_1.Coordinates),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, decorators_1.Describe)('Coordinates where object placed'),
    __metadata("design:type", game_related_1.Coordinates)
], ObjectPlaceDTO.prototype, "coordinates", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => game_related_1.ProximityEffectOptional),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Array of proximity effects'),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, decorators_1.Describe)('Array of proximity effects'),
    __metadata("design:type", Array)
], ObjectPlaceDTO.prototype, "proximityEffects", void 0);
ObjectPlaceDTO = __decorate([
    (0, decorators_1.Describe)('Object placed event')
], ObjectPlaceDTO);
exports.ObjectPlaceDTO = ObjectPlaceDTO;
let ObjectRemoveDTO = class ObjectRemoveDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.ObjectRemoveDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "objectId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "objectName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "objectType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boardId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNFT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "costCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coordinates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Object ID'),
    __metadata("design:type", String)
], ObjectRemoveDTO.prototype, "objectId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Object name'),
    __metadata("design:type", String)
], ObjectRemoveDTO.prototype, "objectName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Object type'),
    __metadata("design:type", String)
], ObjectRemoveDTO.prototype, "objectType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Board ID'),
    __metadata("design:type", String)
], ObjectRemoveDTO.prototype, "boardId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Is object an NFT?'),
    __metadata("design:type", Boolean)
], ObjectRemoveDTO.prototype, "isNFT", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Cost of removing object'),
    __metadata("design:type", Number)
], ObjectRemoveDTO.prototype, "cost", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency of cost'),
    __metadata("design:type", String)
], ObjectRemoveDTO.prototype, "costCurrency", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => game_related_1.Coordinates),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)(),
    (0, decorators_1.Describe)('Coordinates of removed object'),
    __metadata("design:type", game_related_1.Coordinates)
], ObjectRemoveDTO.prototype, "coordinates", void 0);
ObjectRemoveDTO = __decorate([
    (0, decorators_1.Describe)('Object removed event')
], ObjectRemoveDTO);
exports.ObjectRemoveDTO = ObjectRemoveDTO;
let SettingChangeDTO = class SettingChangeDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SettingChangeDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "category", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "previousValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Setting name'),
    __metadata("design:type", String)
], SettingChangeDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Setting category or type'),
    __metadata("design:type", String)
], SettingChangeDTO.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Previous value of setting'),
    __metadata("design:type", String)
], SettingChangeDTO.prototype, "previousValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('New value of setting'),
    __metadata("design:type", String)
], SettingChangeDTO.prototype, "newValue", void 0);
SettingChangeDTO = __decorate([
    (0, decorators_1.Describe)('Setting Change event')
], SettingChangeDTO);
exports.SettingChangeDTO = SettingChangeDTO;
